import { KenoDataServiceAPI } from '@API/gambyt-data-services/keno-api'
import { store } from '@AppState/redux-store'
import { DataFetchingState } from '@AppState/types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TicketHistoryModeState } from './types'
import { TicketInfo } from '@Config/ticket-form-types'
import { SavedKenoTicket } from '@interaction-gaming/player-data-service-browser-client'

const initialState: TicketHistoryModeState = {
  fetchState: DataFetchingState.IDLE,
  savedKenoTickets: [],
  kenoTicketResults: {},
}

export const fetchScoredTicketResults = createAsyncThunk(
  'ticket-history-mode/fetchScoredTicketResults',
  async (savedKenoTicket: SavedKenoTicket) => {
    const result = await KenoDataServiceAPI.fetchKenoTicketResult(savedKenoTicket)
    return {
      id: savedKenoTicket.id,
      result,
    }
  },
)

export const fetchScoredTicketHistory = createAsyncThunk(
  'ticket-history-mode/fetchScoredTicketHistory',
  async () => {
    const appConfig = store.getState().appConfig
    const deviceId = appConfig.config?.clientId
    const playerId = appConfig.config?.playerId

    const ticketHistory = await KenoDataServiceAPI.fetchTicketHistory(deviceId, playerId)
    ticketHistory.forEach((t) => {
      store.dispatch(fetchScoredTicketResults(t))
    })
    return ticketHistory
  },
)

export const saveTicket = createAsyncThunk(
  'ticket-history-mode/saveTicket',
  async (ticketInfo: TicketInfo) => {
    const appConfig = store.getState().appConfig
    const deviceId = appConfig.config?.clientId
    const playerId = appConfig.config?.playerId

    let savedTicket = null
    if (ticketInfo.id) {
      savedTicket = await KenoDataServiceAPI.updateTicket(ticketInfo, deviceId, playerId)
    } else {
      savedTicket = await KenoDataServiceAPI.saveTicket(ticketInfo, deviceId, playerId)
    }

    store.dispatch(fetchScoredTicketResults(savedTicket))

    return savedTicket
  },
)

export const ticketHistoryModeSlice = createSlice({
  name: 'ticket-history',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchScoredTicketHistory.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.savedKenoTickets = action.payload
    })
    builder.addCase(fetchScoredTicketHistory.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
    })
    builder.addCase(fetchScoredTicketHistory.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
    })
    builder.addCase(saveTicket.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      const savedTicket = action.payload!

      const existingTicketIndex = state.savedKenoTickets.findIndex(
        (ticket) => ticket.id === savedTicket.id,
      )

      if (existingTicketIndex > -1) {
        state.savedKenoTickets[existingTicketIndex] = savedTicket
      } else {
        state.savedKenoTickets.push(savedTicket)
      }
    })
    builder.addCase(fetchScoredTicketResults.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.kenoTicketResults[action.payload.id] = action.payload.result
    })
  },
})

export const TicketHistoryModeActions = {
  ...ticketHistoryModeSlice.actions,
}

export const TicketHistoryModeReducer = ticketHistoryModeSlice.reducer
